import { objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { ARROW_SPACER, ARROW_SHIFT, ARROW_WIDTH } from './Tooltip.constants.js';

var CENTER_POSITION_PERCENTAGE = '50%';
var ARROW_SHIFT_PX = "".concat(ARROW_SHIFT, "px");
var getArrowPositions = function getArrowPositions(arrowColour) {
  var borderStyles = {
    bottom: {
      borderBottomColor: "".concat(arrowColour),
      bottom: '100%'
    },
    left: {
      borderLeftColor: "".concat(arrowColour),
      left: '100%'
    },
    right: {
      borderRightColor: "".concat(arrowColour),
      right: '100%'
    },
    top: {
      borderTopColor: "".concat(arrowColour),
      top: '100%'
    }
  };
  var arrowPosition = {
    'bottom-centre': _objectSpread2(_objectSpread2({}, borderStyles.bottom), {}, {
      left: CENTER_POSITION_PERCENTAGE,
      transform: 'translateX(-50%)'
    }),
    'bottom-end': _objectSpread2(_objectSpread2({}, borderStyles.bottom), {}, {
      right: ARROW_SHIFT_PX
    }),
    'bottom-start': _objectSpread2(_objectSpread2({}, borderStyles.bottom), {}, {
      left: ARROW_SHIFT_PX
    }),
    'left-centre': _objectSpread2(_objectSpread2({}, borderStyles.left), {}, {
      top: CENTER_POSITION_PERCENTAGE,
      transform: 'translateY(-50%)'
    }),
    'left-end': _objectSpread2(_objectSpread2({}, borderStyles.left), {}, {
      bottom: ARROW_SHIFT_PX
    }),
    'left-start': _objectSpread2(_objectSpread2({}, borderStyles.left), {}, {
      top: ARROW_SHIFT_PX
    }),
    'right-center': _objectSpread2(_objectSpread2({}, borderStyles.right), {}, {
      top: CENTER_POSITION_PERCENTAGE,
      transform: 'translateY(-50%)'
    }),
    'right-end': _objectSpread2(_objectSpread2({}, borderStyles.right), {}, {
      bottom: ARROW_SHIFT_PX
    }),
    'right-start': _objectSpread2(_objectSpread2({}, borderStyles.right), {}, {
      top: ARROW_SHIFT_PX
    }),
    'top-centre': _objectSpread2(_objectSpread2({}, borderStyles.top), {}, {
      left: CENTER_POSITION_PERCENTAGE,
      transform: 'translateX(-50%)'
    }),
    'top-end': _objectSpread2(_objectSpread2({}, borderStyles.top), {}, {
      right: ARROW_SHIFT_PX
    }),
    'top-start': _objectSpread2(_objectSpread2({}, borderStyles.top), {}, {
      left: ARROW_SHIFT_PX
    })
  };
  return arrowPosition;
};
var GetArrowCssStyles = function GetArrowCssStyles(styles) {
  return Object.entries(styles).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      property = _ref2[0],
      value = _ref2[1];
    return "".concat(property.replace(/([A-Z])/g, '-$1').toLowerCase(), ": ").concat(value, ";");
  }).join('\n');
};
var getArrowPosition = function getArrowPosition(theme, placement) {
  var arrowColour = theme.colours.graphics.primary.main;
  var arrowPositions = getArrowPositions(arrowColour);
  var position = arrowPositions[placement];
  if (!position) return '';
  return "\n  &::after {\n      content: ' ';\n      position: absolute;\n      border: 5px solid transparent;\n      border-style: solid;\n     ".concat(GetArrowCssStyles(position), "\n    }");
};
var calculateLeftPosition = function calculateLeftPosition(containerRect, placement) {
  var width = containerRect.width,
    left = containerRect.left;
  var halfContainerWidth = width / 2;
  switch (placement) {
    case 'top-start':
    case 'bottom-start':
      return left + halfContainerWidth - ARROW_SHIFT - ARROW_WIDTH;
    case 'top-end':
    case 'bottom-end':
      return left - halfContainerWidth + ARROW_SHIFT + ARROW_WIDTH;
    case 'left-centre':
    case 'left-start':
    case 'left-end':
      return left - ARROW_SPACER;
    case 'right-center':
    case 'right-start':
    case 'right-end':
      return left + ARROW_SPACER;
    default:
      return left;
  }
};
var calculateTopPosition = function calculateTopPosition(containerRect, placement) {
  var top = containerRect.top,
    height = containerRect.height;
  var halfContainerHeight = height / 2;
  switch (placement) {
    case 'top-centre':
    case 'top-start':
    case 'top-end':
      return top - ARROW_SPACER;
    case 'bottom-centre':
    case 'bottom-start':
    case 'bottom-end':
      return top + ARROW_SPACER;
    case 'left-start':
    case 'right-start':
      return top + halfContainerHeight - ARROW_SHIFT - ARROW_WIDTH;
    case 'left-end':
    case 'right-end':
      return top - halfContainerHeight + ARROW_SHIFT + ARROW_WIDTH;
    default:
      return top;
  }
};
var getBoundingClientWithArrowShift = function getBoundingClientWithArrowShift(containerRect, placement) {
  if (!containerRect) return null;
  return {
    bottom: containerRect.bottom,
    height: containerRect.height,
    left: calculateLeftPosition(containerRect, placement),
    right: containerRect.right,
    top: calculateTopPosition(containerRect, placement),
    width: containerRect.width,
    x: containerRect.x,
    y: containerRect.y
  };
};

export { calculateLeftPosition, calculateTopPosition, getArrowPosition, getArrowPositions, getBoundingClientWithArrowShift };
//# sourceMappingURL=Tooltip.helpers.js.map
